const API_BASE = 'https://api.dictionaryapi.dev/api/v2/entries/en';

export async function fetchDefinitionForWord(term: string): Promise<string> {
  if (!term || !term.trim()) {
    throw new Error('Please enter a word to look up.');
  }

  const response = await fetch(`${API_BASE}/${encodeURIComponent(term.trim())}`);
  if (!response.ok) {
    throw new Error('Definition not found. Try writing your own.');
  }

  const payload = await response.json();
  const definition =
    payload?.[0]?.meanings?.[0]?.definitions?.[0]?.definition ||
    payload?.[0]?.meanings?.[0]?.definitions?.[0]?.definition ||
    '';

  if (!definition) {
    throw new Error('Definition not found. Try writing your own.');
  }

  return definition;
}

